/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Vue} from 'vue-property-decorator'
import AnalysisNetworkMap from '@/components/analysis/AnalysisNetworkMap'
import {DestinationHostVO} from '@/valueObjects/DestinationHostVO'
import AnalysisNetworkStreams from '@/components/analysis/AnalysisNetworkStreams'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import {AnalysisService} from '@/services/AnalysisService'
import MessageBox from '@/components/shared/MessageBox'
import Download from '@/utils/Download'

@Component({
    components: {
        AnalysisNetworkMap,
        AnalysisNetworkStreams,
        MessageBox,
    },
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisNetworkActivity extends Vue {

    private analysisService: AnalysisService
    private destinationHosts: DestinationHostVO[] = []
    private expandedDestinationHosts: string[] = []
    private streamsErrorMessage: string = ''

    public async mounted() {
        if (this.$route.params.analysisId !== undefined) {
            await this.loadAnalysisNetworkActivity(Number(this.$route.params.analysisId))
        }
    }

    private async loadAnalysisNetworkActivity(analysisId: number): Promise<void> {
        try {
            this.destinationHosts = await this.analysisService.getAnalysisNetworkActivity(analysisId)
        } catch (e) {
            const errorMessage = `Failed to load network activity: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }

    private async downloadAnalysisNetwork(): Promise<void> {
        try {
            const data = await this.analysisService.downloadAnalysisNetwork(Number(this.$route.params.analysisId))
            Download.makeDownloadLink(data, `network.pcap`)
        } catch (e) {
            const errorMessage = `Failed to download network: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }

    private toggleDestinationHostDetails(destinationHost: DestinationHostVO): void {
        const index = this.expandedDestinationHosts.indexOf(destinationHost.ip)
        if (index > -1) {
            this.expandedDestinationHosts.splice(index, 1)
        } else {
            this.expandedDestinationHosts.push(destinationHost.ip)
        }
    }

    private isDestinationHostDetailsExpanded(destinationHost: DestinationHostVO): boolean {
        return this.expandedDestinationHosts.indexOf(destinationHost.ip) > -1
    }

    private setStreamsErrorMessage(message: string) {
        this.streamsErrorMessage = message
    }

    private clearStreamsErrorMessage(destinationHost: DestinationHostVO) {
        this.streamsErrorMessage = ''
        this.toggleDestinationHostDetails(destinationHost)
    }
}
